/**
 * INCENTIVE-TRACKER MODULE
 * Self-contained. Import only from /shared or within this module.
 *
 * One line describing what a goal is measured against — the accounts and the
 * SKUs (item 233). Rendered read-only wherever a goal is shown outside the draft
 * editor, so the scope a rep set is visible on the scoring screen, the program
 * summary and the distributor view rather than living only in the database.
 */

function names(list, max = 4) {
  const arr = (Array.isArray(list) ? list : []).map((x) => x?.name || x?.id).filter(Boolean);
  if (arr.length === 0) return null;
  if (arr.length <= max) return arr.join(", ");
  return `${arr.slice(0, max).join(", ")} +${arr.length - max} more`;
}

export default function GoalScope({ goal, compact = false }) {
  const accounts = names(goal?.target_accounts);
  const products = names(goal?.target_products);
  if (!accounts && !products) {
    return compact ? null : <p className="it-scope">All accounts · all SKUs</p>;
  }
  return (
    <p className="it-scope">
      <span><strong>Accounts:</strong> {accounts || "all"}</span>
      <span><strong>SKUs:</strong> {products || "all"}</span>
    </p>
  );
}
